
import { Listing } from '@df/catalog-ui/listing/listing';
import { ISortOptions } from '@df/catalog-ui/listing/sort/abstract-async.engine';
import { IProductData, Product } from '@df/catalog/product/product';
import { ListingSortKlevuEngine as ListingSortKlevuEngineCore } from '@df/module-klevu-search/listing-sort-klevu.engine';
export class LocalListingSortKlevuEngine extends ListingSortKlevuEngineCore {
    protected override getSortOptions(listing: Listing<Product<IProductData>>): ISortOptions {
        const sortOptions = super.getSortOptions(listing);
        sortOptions.bannerPositionsUnchanged = false;
        return sortOptions;
    }
}
